import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = { class: "p-mx-2" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { id: "printableBalanceSheet" }
const _hoisted_5 = { class: "m-2 mt-4 mb-4 p-text-center" }
const _hoisted_6 = { class: "p-mt-2" }
const _hoisted_7 = { class: "table table-bordered table-hover" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("tr", { style: {"background-color":"#004C97","color":"#fff"} }, [
  /*#__PURE__*/_createElementVNode("th", {
    class: "p-p-1",
    colspan: "2"
  }, "ASSETS")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("tr", { style: {"background-color":"#e8e8e8"} }, [
  /*#__PURE__*/_createElementVNode("td", {
    class: "p-p-1",
    colspan: "2"
  }, [
    /*#__PURE__*/_createElementVNode("b", null, "Current Assets")
  ])
], -1)
const _hoisted_10 = { class: "p-p-1" }
const _hoisted_11 = { class: "p-p-1" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("tr", { style: {"background-color":"#e8e8e8"} }, [
  /*#__PURE__*/_createElementVNode("td", {
    class: "p-p-1",
    colspan: "2"
  }, [
    /*#__PURE__*/_createElementVNode("b", null, "Non-Current Assets")
  ])
], -1)
const _hoisted_13 = { class: "p-p-1" }
const _hoisted_14 = { class: "p-p-1" }
const _hoisted_15 = { style: {"background-color":"#ccc"} }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", { class: "p-p-1" }, "Total Assets", -1)
const _hoisted_17 = { class: "p-p-1" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("tr", { style: {"background-color":"#004C97","color":"#fff"} }, [
  /*#__PURE__*/_createElementVNode("th", {
    class: "p-p-1",
    colspan: "2"
  }, "LIABILITIES")
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("tr", { style: {"background-color":"#e8e8e8"} }, [
  /*#__PURE__*/_createElementVNode("td", {
    class: "p-p-1",
    colspan: "2"
  }, [
    /*#__PURE__*/_createElementVNode("b", null, "Current Liabilities")
  ])
], -1)
const _hoisted_20 = { class: "p-p-1" }
const _hoisted_21 = { class: "p-p-1" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("tr", { style: {"background-color":"#e8e8e8"} }, [
  /*#__PURE__*/_createElementVNode("td", {
    class: "p-p-1",
    colspan: "2"
  }, [
    /*#__PURE__*/_createElementVNode("b", null, "Non-Current Liabilities")
  ])
], -1)
const _hoisted_23 = { class: "p-p-1" }
const _hoisted_24 = { class: "p-p-1" }
const _hoisted_25 = { style: {"background-color":"#ccc"} }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("td", { class: "p-p-1" }, "Total Liabilities", -1)
const _hoisted_27 = { class: "p-p-1" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("tr", { style: {"background-color":"#004C97","color":"#fff"} }, [
  /*#__PURE__*/_createElementVNode("th", {
    class: "p-p-1",
    colspan: "2"
  }, "EQUITY")
], -1)
const _hoisted_29 = { class: "p-p-1" }
const _hoisted_30 = { class: "p-p-1" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("td", { class: "p-p-1" }, "Current Period Net Profit/Loss", -1)
const _hoisted_32 = { class: "p-p-1" }
const _hoisted_33 = { style: {"background-color":"#ccc"} }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("td", { class: "p-p-1" }, "Total Equity", -1)
const _hoisted_35 = { class: "p-p-1" }
const _hoisted_36 = { style: {"background-color":"#9fc5e8"} }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("td", { class: "p-p-1" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Total Liabilities + Equity")
], -1)
const _hoisted_38 = { class: "p-p-1" }
const _hoisted_39 = { class: "p-p-1" }
const _hoisted_40 = { class: "p-p-1" }
const _hoisted_41 = { class: "p-dialog-titlebar p-dialog-titlebar-icon" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-search",
  style: {"font-size":"1.2rem"}
}, null, -1)
const _hoisted_43 = { class: "p-field" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", { for: "filterStore" }, "Filter Date", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("h5", null, "OR", -1)
const _hoisted_46 = { class: "p-grid" }
const _hoisted_47 = { class: "p-col" }
const _hoisted_48 = { class: "p-field" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("label", { for: "from" }, "Date From", -1)
const _hoisted_50 = { class: "p-col" }
const _hoisted_51 = { class: "p-field" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("label", { for: "to" }, "Date To", -1)
const _hoisted_53 = { class: "p-grid pt-3" }
const _hoisted_54 = { class: "p-col" }
const _hoisted_55 = { class: "p-field" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("label", { for: "filterStore" }, "Branch", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Toolbar, null, {
        start: _withCtx(() => [
          _createVNode(_component_Breadcrumb, {
            home: _ctx.home,
            model: _ctx.items,
            class: "p-menuitem-text p-p-1"
          }, null, 8, ["home", "model"])
        ]),
        end: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Button, {
              icon: "pi pi-search",
              class: "p-button-success px-4",
              onClick: _ctx.openDialog
            }, null, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Button, {
              icon: "pi pi-print",
              class: "p-button-primary px-4",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.printReceiptUtil('printableBalanceSheet', _ctx.storeName + ' Balance Sheet')))
            })
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h5", null, _toDisplayString(_ctx.storeName) + " Balance Sheet", 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.resultTitle), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("table", _hoisted_7, [
            _hoisted_8,
            (_ctx.currentAssets.length)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_9,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentAssets, (a) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: a.accountName
                    }, [
                      _createElementVNode("td", _hoisted_10, _toDisplayString(a.accountName), 1),
                      _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatBalance(a.balance)), 1)
                    ]))
                  }), 128))
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.nonCurrentAssets.length)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_12,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nonCurrentAssets, (a) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: a.accountName
                    }, [
                      _createElementVNode("td", _hoisted_13, _toDisplayString(a.accountName), 1),
                      _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatBalance(a.balance)), 1)
                    ]))
                  }), 128))
                ], 64))
              : _createCommentVNode("", true),
            _createElementVNode("tr", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatBalance(_ctx.totalAssets)), 1)
            ]),
            _hoisted_18,
            (_ctx.currentLiabilities.length)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _hoisted_19,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentLiabilities, (l) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: l.accountName
                    }, [
                      _createElementVNode("td", _hoisted_20, _toDisplayString(l.accountName), 1),
                      _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatBalance(l.balance)), 1)
                    ]))
                  }), 128))
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.nonCurrentLiabilities.length)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  _hoisted_22,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nonCurrentLiabilities, (l) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: l.accountName
                    }, [
                      _createElementVNode("td", _hoisted_23, _toDisplayString(l.accountName), 1),
                      _createElementVNode("td", _hoisted_24, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatBalance(l.balance)), 1)
                    ]))
                  }), 128))
                ], 64))
              : _createCommentVNode("", true),
            _createElementVNode("tr", _hoisted_25, [
              _hoisted_26,
              _createElementVNode("td", _hoisted_27, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatBalance(_ctx.totalLiabilities)), 1)
            ]),
            _hoisted_28,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.equityAccounts, (e) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: e.accountName
              }, [
                _createElementVNode("td", _hoisted_29, _toDisplayString(e.accountName), 1),
                _createElementVNode("td", _hoisted_30, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatBalance(e.balance)), 1)
              ]))
            }), 128)),
            _createElementVNode("tr", null, [
              _hoisted_31,
              _createElementVNode("td", _hoisted_32, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatBalance(_ctx.netProfit)), 1)
            ]),
            _createElementVNode("tr", _hoisted_33, [
              _hoisted_34,
              _createElementVNode("td", _hoisted_35, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatBalance(_ctx.totalEquity)), 1)
            ]),
            _createElementVNode("tr", _hoisted_36, [
              _hoisted_37,
              _createElementVNode("td", _hoisted_38, [
                _createElementVNode("b", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatBalance(_ctx.totalLiabilitiesAndEquity)), 1)
              ])
            ]),
            _createElementVNode("tr", {
              style: _normalizeStyle(_ctx.isBalanced ? 'background-color:green; color:#fff;' : 'background-color:#b91c1c; color:#fff;')
            }, [
              _createElementVNode("td", _hoisted_39, _toDisplayString(_ctx.isBalanced ? 'Balanced' : 'Out of Balance'), 1),
              _createElementVNode("td", _hoisted_40, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.balanceDifference)), 1)
            ], 4)
          ])
        ])
      ]),
      _createVNode(_component_Dialog, {
        visible: _ctx.productDialog,
        "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.productDialog) = $event)),
        style: { width: '50vw' },
        maximizable: true,
        position: "top",
        class: "p-fluid"
      }, {
        header: _withCtx(() => [
          _createElementVNode("h5", _hoisted_41, [
            _hoisted_42,
            _createTextVNode(" " + _toDisplayString(_ctx.dialogTitle), 1)
          ])
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_Button, {
            type: "submit",
            label: "Search",
            icon: "pi pi-search",
            class: "p-button-primary",
            onClick: _ctx.loadList
          }, null, 8, ["onClick"])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_43, [
            _hoisted_44,
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.searchFilters.filterType,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchFilters.filterType) = $event)),
              options: _ctx.filterDates,
              onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clearForFilters())),
              filter: true,
              optionLabel: "key",
              optionValue: "value"
            }, null, 8, ["modelValue", "options"])
          ]),
          _hoisted_45,
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                _hoisted_49,
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  id: "from",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchFilters.date1) = $event)),
                  onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clearSearch && _ctx.clearSearch(...args))),
                  class: "form-control"
                }, null, 544), [
                  [_vModelText, _ctx.searchFilters.date1]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("div", _hoisted_51, [
                _hoisted_52,
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  id: "to",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchFilters.date2) = $event)),
                  onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.clearSearch && _ctx.clearSearch(...args))),
                  class: "form-control"
                }, null, 544), [
                  [_vModelText, _ctx.searchFilters.date2]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("div", _hoisted_55, [
                _hoisted_56,
                _createVNode(_component_Dropdown, {
                  modelValue: _ctx.searchFilters.storeID,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.searchFilters.storeID) = $event)),
                  options: _ctx.filterBranch,
                  filter: true,
                  optionLabel: "name",
                  optionValue: "id"
                }, null, 8, ["modelValue", "options"])
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"])
    ])
  ]))
}